module.exports = __webpack_public_path__ + "img/ic_buildings.e7c6d6db.svg";